import { NavLink, Outlet } from "react-router-dom";
import { isAdmin } from "../../store/app";
import { useApp } from "../../store/hooks";

export function SettingsLayout() {
  // Re-render when membership changes.
  useApp((s) => s.orgId);
  const admin = isAdmin();
  return (
    <div className="page settings">
      <header className="page-head">
        <h1>Settings</h1>
      </header>
      <nav className="tabs" aria-label="Settings sections">
        <NavLink to="/settings/connections">Connections</NavLink>
        {admin && <NavLink to="/admin/identities">People &amp; identities ↗</NavLink>}
      </nav>
      <Outlet />
    </div>
  );
}
